import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationListItem } from '../services/application.common.model';

@Pipe({
  name: 'savedListApplicationUrl',
  standalone: true
})
export class SavedListApplicationUrlPipe implements PipeTransform {

  transform(item: ApplicationListItem): string {
    const externalServiceUrls: string[] = [
      '/wykonanie-projektow-organizacji-ruchu'
    ];
    if (externalServiceUrls.includes(item.application?.service?.url || '')) {
      return '/wnioski-robocze' + item.application?.service?.url + '/' + item.application?.uuid;
    }
    return '/wnioski-robocze' + item.application?.service?.url + '/' + item.application?.uuid + '/wnioskodawca';
  }

}
